import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { themeStyle, themeStyleDark } from "../components/Components";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import {
  ContentSideBySide,
  ContentSideBySideInv,
  ThreeSideBySide,
  Hero,
  Gallery,
  Stats,
  SpacerV,
} from "../components/Hero";
import { API_URL } from "../actions/auth";
import axios from "axios";
import { useNavigate } from "react-router";
import { TypeAnimation } from "react-type-animation";
import Lottie from "react-lottie";
import {
  OurProcess,
  Advantages,
  YouWillGet,
  Collage,
  FAQ2,
  Collage2,
  Trust,
  Tailor,
} from "../components/Sections";
import { layout } from "../components/Layout";

export default function EndToEndAnalytics() {
  const [news, setNews] = useState([]);
  const navigate = useNavigate();
  const state = useSelector((state) => state);
  const dark = false;

  function getContent() {
    return (
      <div className="main">
        <Sidebar />
        <div
          className="anigrad"
          style={{ backgroundColor: dark ? "#111" : "white" }}
        >
          <div
            style={{
              height: state.auth.isMobile ? "130vh" : "100vh",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              width: "100vw",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                width: "75vw",
              }}
            >
              <div
                style={{
                  marginTop: state.auth.isMobile
                    ? state.auth.isTablet
                      ? "-300px"
                      : "-135px"
                    : "0px",
                  fontSize: state.auth.isMobile ? "25px" : "6vh",
                  color: "white",
                  zIndex: 999,
                  textAlign: "left",
                  marginBottom: "25px",
                  fontWeight: "bold",
                }}
              >
                <div
                  style={{
                    fontSize: layout.heading2[state.auth.view],
                  }}
                >
                  End to End Analytics for Data-Driven Success
                </div>
              </div>
              <div
                style={{
                  fontSize: layout.textMedium[state.auth.view],
                  color: "white",
                  zIndex: 999,
                  textAlign: "left",
                }}
              >
                We refine every stage of the data journey to extract meaningful
                business intelligence. Our end-to-end analytics solutions
                process, analyze, and visualize complex data. This makes sure
                that businesses extract precise insights for informed
                decision-making.
              </div>
              <button
                style={{
                  marginTop: "6vh",
                  filter: dark ? "invert(0)" : "invert(1)",
                }}
                onClick={() => {
                  navigate("/get-a-quote/");
                }}
                className="squishy"
              >
                Request a free estimate
              </button>
              <div
                style={{
                  display:
                    state.auth.isMobile || state.auth.view == "TABP"
                      ? "none"
                      : "block",
                }}
              >
                <Tailor
                  invert
                  title1="Actionable Insights"
                  subtitle1="Uncover trends to drive smarter decisions."
                  title2="Real-Time Tracking"
                  subtitle2="Monitor user behavior as it happens."
                  title3="Simplified Reporting"
                  subtitle3="Turn complex data into clear visuals."
                />
              </div>
            </div>
          </div>
          <Stats />
          {state.auth.isTablet ? (
            <SpacerV height={"300px"} background="#111" />
          ) : (
            ""
          )}
          <ContentSideBySide
            dark={dark}
            title={
              <h2>
                End-to-End Analytics Services for Smarter Business Decisions
              </h2>
            }
            subtitle={
              <div>
                At Riches Media Digital, we implement data strategies that
                improve efficiency and drive measurable business outcomes. Our
                team handles data collection and transformation to ensure
                accuracy. We also build interactive dashboards that simplify
                data interpretation. Our structured approach improves reporting
                and streamlines decision-making.
              </div>
            }
            image={
              <Lottie
                options={{
                  loop: true,
                  autoplay: true,
                  animationData: require("../img/marketing (8).json"),
                  rendererSettings: {
                    preserveAspectRatio: "xMidYMid slice",
                  },
                }}
                height={state.auth.isMobile ? 350 : 500}
                width={state.auth.isMobile ? 350 : 500}
                isStopped={false}
                isPaused={false}
              />
            }
          />
          <SpacerV height={"100px"} background={dark ? "#111" : "white"} />
          <OurProcess
            process={"Our End-to-End Analytics Process"}
            invert={!dark}
            step1={"Data Collection and Integration"}
            step1description={
              "We gather structured and unstructured data from multiple sources. Our team integrates datasets and removes inconsistencies. We also validate data points to improve accuracy."
            }
            step2={"Data Processing and Transformation"}
            step2description={
              "We clean and structure raw data to improve usability. Our team applies automation and scalable pipelines. We also refine data formats to ensure consistency."
            }
            step3={"Advanced Analytics and Reporting"}
            step3description={
              "We conduct deep analysis and extract patterns from data. Our team builds custom reports and interactive dashboards. We also integrate predictive analytics to improve forecasting."
            }
            step4={"Real-Time Data Monitoring and Insights"}
            step4description={
              "We track live data streams and detect performance fluctuations. Our team sets up real-time alerts and anomaly detection. We also analyze key trends to improve business strategies."
            }
          />
          <Advantages
            invert={!dark}
            title={"Advantages of Our End-to-End Analytics Solutions"}
            title1={"Data-Driven Decision Making"}
            subtitle1={
              "We structure and analyze data to improve business intelligence. A streamlined approach ensures clarity in reporting."
            }
            title2={"Improved Data Accuracy"}
            subtitle2={
              "Our experts clean and validate datasets to improve reliability. This strengthens insights and minimizes errors."
            }
            title3={"Faster Reporting and Insights"}
            subtitle3={
              "We automate reporting workflows and reduce processing delays. This improves operational efficiency and supports better forecasting."
            }
            title4={"Scalable and Secure Data Solutions"}
            subtitle4={
              "We structure analytics frameworks that grow with business needs. Security measures protect data integrity and prevent breaches."
            }
          />
          <ContentSideBySideInv
            dark={dark}
            title={
              <h2>
                Turn Data into Competitive Advantage with Full-Scale Analytics
              </h2>
            }
            subtitle="At Riches Media Digital, we convert complex data into actionable intelligence that drives business growth. Our end-to-end analytics solutions eliminate inefficiencies and refine data processing. We structure, analyze, and visualize key metrics. This promises that every insight leads to smarter decisions and higher profitability. Be it performance tracking or predictive forecasting, we implement data-backed solutions that optimize business strategies and maximize outcomes."
            image={
              <img
                alt={"End to End Analytics"}
                style={{ width: "100%", borderRadius: "25px" }}
                src={require("../img/banner.png")}
              />
            }
          />
          <SpacerV height={"100px"} background={dark ? "#111" : "white"} />
          <YouWillGet
            willget={"What End-to-End Analytics Services Will You Get"}
            invert={!dark}
            title1={"End-to-End Data Processing Solutions"}
            title2={"Custom Dashboards and Reporting Tools"}
            title3={"Scalable and Automated Data Pipelines"}
            title4={"Real-Time Monitoring and Predictive Analytics"}
            title5={"Advanced Data Security and Compliance Management"}
          />
          <div
            style={{
              display:
                state.auth.isMobile || state.auth.view == "TABP"
                  ? "none"
                  : "block",
            }}
          >
            <Trust invert />
          </div>
          <FAQ2
            invert={!dark}
            q1="What is End-to-End Analytics?"
            a1="End-to-end analytics covers data collection and transformation to improve decision-making. It further encircles dashboard development and predictive analysis to track performance effectively."
            q2="Why is data analytics important for businesses?"
            a2="Analytics improves reporting accuracy and strengthens forecasting capabilities. Businesses that utilize structured analytics refine decision-making and improve operational efficiency."
            q3="How long does it take to implement analytics solutions?"
            a3="Implementation timelines vary based on data complexity and reporting needs. Businesses see structured reports and insights within four to ten weeks depending on data volume and automation levels."
            q4="What are the key factors that impact analytics success?"
            a4="Analytics success depends on data quality and reporting frameworks. Structured processing and predictive modeling further improve decision-making capabilities."
            q5="How do you ensure data accuracy?"
            a5="We apply data validation techniques and cleansing processes to remove inconsistencies. Our team builds automated pipelines and real-time monitoring systems to strengthen data integrity."
            q6="How can analytics improve business performance?"
            a6="Analytics improves operational efficiency and revenue forecasting. Businesses that utilize real-time insights and automated reports identify trends faster and optimize strategies effectively."
          />
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor:
          state.auth.theme == "dark"
            ? themeStyleDark.backgroundColor
            : themeStyle.backgroundColor,
        transition: "opacity 2s",
      }}
    >
      {getContent()}
    </div>
  );
}
